// ** Icon imports

// ** Type import

import navigation from 'src/configs/navigationMenu'

export default navigation
